import { defineMessages } from '@openedx/frontend-base';

const messages = defineMessages({
  dashboard: {
    id: 'learnerVariantDashboard.menu.dashboard.label',
    defaultMessage: 'Dashboard',
    description: 'The text for the user menu Dashboard navigation link.',
  },
  dashboardPersonal: {
    id: 'learnerVariantDashboard.menu.dashboardPersonal.label',
    defaultMessage: 'Personal',
    description: 'Link to personal dashboard in user menu',
  },
  dashboardSwitch: {
    id: 'learnerVariantDashboard.menu.dashboardSwitch.label',
    defaultMessage: 'SWITCH DASHBOARD',
    description: 'Switch Dashboard header in the user menu',
  },
  profile: {
    id: 'learnerVariantDashboard.menu.profile.label',
    defaultMessage: 'Profile',
    description: 'The text for the user menu Profile navigation link.',
  },
  viewPrograms: {
    id: 'learnerVariantDashboard.menu.viewPrograms.label',
    defaultMessage: 'View Programs',
    description: 'The text for the user menu View Programs navigation link.',
  },
  account: {
    id: 'learnerVariantDashboard.menu.account.label',
    defaultMessage: 'Account',
    description: 'The text for the user menu Account navigation link.',
  },
  orderHistory: {
    id: 'learnerVariantDashboard.menu.orderHistory.label',
    defaultMessage: 'Order History',
    description: 'The text for the user menu Order History navigation link.',
  },
  signOut: {
    id: 'learnerVariantDashboard.menu.signOut.label',
    defaultMessage: 'Sign Out',
    description: 'The label for the user menu Sign Out action.',
  },
  course: {
    id: 'learnerVariantDashboard.course',
    defaultMessage: 'Courses',
    description: 'Header link for switching to dashboard page.',
  },
  program: {
    id: 'learnerVariantDashboard.program',
    defaultMessage: 'Programs',
    description: 'Header link for switching to program page.',
  },
  discoverNew: {
    id: 'learnerVariantDashboard.discoverNew',
    defaultMessage: 'Discover New',
    description: 'Header link for switching to discover page.',
  },
  logoAltText: {
    id: 'learnerVariantDashboard.logoAltText',
    defaultMessage: 'edX, Inc. Dashboard',
    description: 'Alt text for the edX logo.',
  },
  collapseMenuOpenAltText: {
    id: 'learnerVariantDashboard.collapseMenuOpenAltText',
    defaultMessage: 'Menu',
    description: 'Alt text for the collapse menu icon when the menu is open.',
  },
  collapseMenuClosedAltText: {
    id: 'learnerVariantDashboard.collapseMenuClosedAltText',
    defaultMessage: 'Close',
    description: 'Alt text for the collapse menu icon when the menu is closed.',
  },
  career: {
    id: 'leanerDashboard.menu.career.label',
    defaultMessage: 'Career',
    description: 'The text for the user menu Career navigation link.',
  },
  newAlert: {
    id: 'header.menu.new.label',
    defaultMessage: 'New',
    description: 'The text announcing that an item in the user menu is New',
  },
});

export default messages;
